import {styled} from '@mui/material/styles';
import React, {useEffect} from 'react';

import CustomButtonGroup from '../../components/CustomButtonGroup/CustomButtonGroup';
import CustomSnackBar from '../../components/CustomSnackBar/CustomSnackBar';
import {ToastArchiveConfirmationIcon} from '../../constants/icons';

const StyledCustomButtonGroup = styled(CustomButtonGroup)(({theme}) => ({
  display: 'flex',
  flex: `0 0 70px`,
  marginLeft: theme.spacing(1),
  flexDirection: 'column',
  borderLeft: `1px solid ${theme.palette.grey[300]}`,
  justifyContent: 'end',
  alignSelf: 'end',
  '& .custom-button': {
    minWidth: 40,
    flex: '0 0 auto',
    '&:first-of-type': {
      borderColor: theme.palette.grey[100],
      color: theme.palette.grey[100],
      marginTop: 0,
    },
    '&:last-of-type': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[100],
      marginBottom: 0,
    },
  },
}));

function CustomToast({message, isOpen, onHandleSubmit, onHandleClose, Icon, isLoading, buttons = {}}) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    onHandleClose && onHandleClose();
  };

  const handleSubmit = () => {
    onHandleSubmit && onHandleSubmit();
  };

  useEffect(() => {
    setOpen(isOpen || false);
  }, [isOpen]);

  const Buttons = () => (
    <StyledCustomButtonGroup
      first={{
        text: 'Yes',
        color: 'primary',
        variant: 'outlined',
        onClick: handleSubmit,
        size: 'small',
        ...buttons.first,
      }}
      second={{
        text: 'No',
        color: 'primary',
        variant: 'contained',
        size: 'small',
        onClick: handleClose,
        ...buttons.second,
      }}
      isLoading={isLoading}
    />
  );

  return (
    <CustomSnackBar
      autoHideDuration={null}
      ActionComponent={Buttons}
      message={message}
      isOpen={open}
      Icon={Icon || ToastArchiveConfirmationIcon}
      handleClose={handleClose}
      anchorOriginVertical={'bottom'}
    />
  );
}

export default CustomToast;
